/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { Checkbox, Heading } from 'sarsaparilla';

import { SEARCH_FILTER_TOUR_TYPE } from '../../../constants/index';

type TourTypeFilterItem = {
    key: string;
    value: string;
    filters: { attribute: string; filterValue: string }[];
};

interface TourTypeFiltersProps {
    uiFilters: {
        tourTypes?: Record<string, unknown>;
    };
    onFilterToggle: (filterName: string, item: TourTypeFilterItem) => void;
}

/** Tour type checkboxes. Every tour type can be selected. */
export function TourTypeFilters({ uiFilters, onFilterToggle }: TourTypeFiltersProps) {
    const selections = uiFilters.tourTypes ?? {};

    return (
        <div>
            <Heading headingLevel={3} appearance="h3" className="mb-2">
                Tour Types
            </Heading>
            <div
                className="search-filters-double-type-wrap"
                role="group"
                aria-label="Tour type filters"
            >
                <legend className="rec-sr-only">Select tour types to filter on</legend>
                {SEARCH_FILTER_TOUR_TYPE.map((item: TourTypeFilterItem) => (
                    <div className="search-filter-check-item" key={item.key}>
                        <Checkbox
                            onChange={() => onFilterToggle('tourTypes', item)}
                            id={item.key}
                            label={item.value}
                            value={item.value}
                            isChecked={Object.hasOwn(selections, item.key)}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
}
